module.exports = {
  init: async function(parent,settings={}){
    this._parent=parent;
    this._settings=settings;
    this._cache=false;
    this._connection_issue=false;
    this._key_prefix='user_settings-';
  },
  has_connectionIssue: function()
  {
    return this._connection_issue;
  },
  get_setting: async function(key,force=false)
  {
    this._parent._log('debug','settings.get_setting',key,this._settings);
    if(key in this._settings)
    {
      this._parent._log('debug','settings.get_setting','Found '+key,this._settings[key]);
      if(!('generated::has_user_data' in this._settings[key]) || !this._settings[key]['generated::has_user_data'] || force)
      {
        let user_data = await this.get(key,force);
        this._parent._log('debug','settings.get_setting','Found Userdata for '+key,user_data);

        let has_user_data=false;
        if(typeof user_data == 'object' && 'data' in user_data)
        {
          has_user_data=true;
        }

        if('fields' in this._settings[key])
        {
          this._parent._log('debug','settings.get_setting','Found '+key+' fields ',this._settings[key].fields);
          for(let i=0;i<this._settings[key].fields.length;i++)
          {

            if('settings' in this._settings[key].fields[i])
            {
              if(typeof this._settings[key].fields[i].settings != 'object')
              {
                let __settings = {};
                let _field_settings=this._settings[key].fields[i].settings.split('|');
                for(let i=0;i<_field_settings.length;i++)
                {
                  let _field_settings_tmp=_field_settings[i].split('=');
                  if(_field_settings_tmp.length>1)
                  {
                    __settings[_field_settings_tmp[0]]=_field_settings_tmp[1];
                  }
                  else
                  {
                    __settings[_field_settings_tmp[0]]=true;
                  }
                }
                this._settings[key].fields[i].settings = __settings;
              }
            }
            else
            {
              this._settings[key].fields[i].settings={};
            }

            if(has_user_data)
            {
              if('user_data' in this._settings[key].fields[i])
              {
                delete this._settings[key].fields[i]['user_data'];
              }
              if('title' in this._settings[key].fields[i])
              {
                if(this._settings[key].fields[i].title in user_data.data)
                {
                  this._settings[key].fields[i]['user_data']=user_data.data[this._settings[key].fields[i].title];
                }
              }
            }
          }
        }
        else
        {
          if(has_user_data)
          {
            this._settings[key]['user_data']=user_data.data;
          }
        }
        this._settings[key]['generated::has_user_data']=true;
      }
      else
      {
        this._parent._log('debug','settings.get_setting','Using cache for '+key+'',this._settings[key]);
      }
      return this._settings[key];
    }
    else
    {
      return false;
    }
  },
  get_settings:function(keys_only=false)
  {
    if(keys_only)
    {
      if(typeof this._settings == 'object')
      {
        return Object.keys(this._settings);
      }
    }
    return this._settings;
  },
  add_setting:function(key,value)
  {
    this._settings[key]=value;
  },
  refresh:async function(key)
  {

    this._cache=false;
    await this.get(key);
    await this.get_setting(key);
  },
  get:async function(key,force=false)
  {
    if(!key && key.length <= 0)
    {
      this._parent._log('debug','settings.get','key is empty',key);
      return false;
    }

    if(!(key in this._settings))
    {
      this._parent._log('debug','settings.get','key missing from known settings',key);
      return false;
    }

    if(force)
    {
      delete this._cache[key];
    }
    this._parent._log('debug','settings.get','Getting '+key, force);
    if(this._cache && typeof this._cache == 'object' && (key in this._cache))
    {
      this._parent._log('debug','settings.get','Has Cache',this._cache[key]);
    }
    else
    {
      if(!(typeof this._cache == 'object'))
      {
        this._cache={};
      }
      this._parent._log('debug','settings.get','No cache');
      this._cache[key] = {'type': 'profile', 'name': this._key_prefix+key, 'data':{}, 'status': 'published'};

      let current_data=true;

      try
      {
        current_data = await this._parent.get('data','?type=profile&name='+this._cache[key].name+'&status=published&_[limit]=1',false,true);
        this._connection_issue=false;
      }
      catch(ex)
      {
        this._connection_issue=true;
        this._parent._log('error','settings.get','data',ex);
      }

      if(Array.isArray(current_data) && current_data.length == 1)
      {
        this._parent._log('debug','settings.get','Processing return',current_data);
        if('data' in current_data[0])
        {
          this._cache[key].data = JSON.parse(JSON.stringify(current_data[0].data));
          this._parent._log('debug','settings.get','From db',this._cache[key]);
        }
        else
        {
          this._parent._log('debug','settings.get','mmm data missing',current_data[0]);
        }
      }
      else
      {
        this._parent._log('warn','settings.get','Ok, no return... probably ok',current_data);
      }
    }
    return this._cache[key];
  },
  has:async function(key,callback=false)
  {
    let current_data = await this.get(key);
    let result = false;
    if(typeof current_data === 'object' && 'data' in current_data)
    {
      result=true;
    }
    if(typeof callback == 'function')
    {
      callback(result);
    }
    return result;
  },
  remove:async function(post_id)
  {
    throw 'Not implemented';
  },
  set:async function(key,data)
  {
    try
    {
      if(key && key.length > 0)
      {
        let current_data = await this.get(key,true);
        if(typeof current_data === 'object' && 'data' in current_data)
        {
          this._parent._log('debug','settings.set['+key+']','Setting to',data);
          current_data.data=data;
          this._parent._log('debug','settings.set['+key+']','Persisting',current_data);

          if('name' in current_data && current_data.name == this._key_prefix+key)
          {
            let result =  await this._parent.post('data',current_data);
            window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
              'event_type':'settings',
              'data': {
                'action':'set',
                'id':key
              }
            }}));
            if(key in this._cache)
            {
              delete this._cache[key];
              this._parent._log('debug','settings.set['+key+']','Clearing _cache for '+key,this._cache);
            }
            await this.get(key);
            if(key in this._settings && 'generated::has_user_data' in this._settings[key])
            {
              this._settings[key]['generated::has_user_data']=false;
              await this.get_setting(key);
              this._parent._log('debug','settings.set['+key+']','Clearing has_user_data',this._settings[key]);
            }
            return result;
          }
          else
          {
            return false;
          }

        }
        else
        {
          throw "current_data is not an object or is missing data";
        }
      }
      else
      {
        throw "key is empty";
      }

    }
    catch(ex)
    {
        this._parent._log('error','settings.set['+key+']',ex);
        return false;
    }

  }
}
